import React from "react";
import { Modal } from "../../Modal";
import { useVariablesContext } from "../../../context/VariablesContext";

export const ThankYou = () => {
    const variables = useVariablesContext();

    return (
        <Modal open={true}>
            <div className={"thank-you-step container"}>
                <h1>Vielen Dank für Ihre Bestellung</h1>
                <p className={"h4"}>
                    Sie erhalten in Kürze eine Bestellbestätigung per E-Mail. Sollten Sie noch Fragen zur Ihrer
                    Bestellung haben, nehmen Sie gerne mit unserem Kundenservice Kontakt auf.
                </p>

                <div className={"links"}>
                    {variables.phone ? (
                        <div className={"button link-wrapper icon-button phone"}>
                            <a href={variables.phone}>{variables.phone.replace("tel:", "")}</a>
                        </div>
                    ) : null}
                    {variables.email ? (
                        <div className={"button link-wrapper icon-button mail"}>
                            <a href={variables.phone}>{variables.email.replace("mailto:", "")}</a>
                        </div>
                    ) : null}
                </div>

                <div className={"buttons"}>
                    <a href={"/konfigurator"} className={"button icon-button primary configurator"}>
                        Weiter konfigurieren
                    </a>
                    <a href={"/"} className={"button icon-button primary home"}>
                        Zur Startseite
                    </a>
                </div>
            </div>
        </Modal>
    );
};
